module.exports = __webpack_public_path__ + "img/payment-visa.5fa902fb.png";